/**
 * Created by gocey on 28.08.17.
 */

Box.Application.addModule('sv-tabs', function(context) {

    var _self = context;

    // retrieve a reference to jQuery
    var $ = context.getGlobal('jQuery');

    var _prepareTabs = function() {
        _self.$element = $(context.getElement());
        _self.$tabs = _self.$element.find('.sv-tabs');
        _self.$tabBtn = _self.$element.find('.button');
        _self.$tabContent = _self.$element.find('.tab-content');
    };

    var _initTabs = function() {
        _self.$tabBtn.click(function() {
            var tab_id = $(this).attr('data-tab');

            _self.$tabBtn.removeClass('current');
            _self.$tabContent.removeClass('current');

            $(this).addClass('current');
            $("#" + tab_id).addClass('current');
        })
    }

    return {

        init: function() {
            _prepareTabs();
            _initTabs();
        }

    };
});



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-tabs.js